import { enumToCapitalCase } from "../components/MarginAccountDetailsTabs/BuyingPowerTab/utils/balanceRollupTools";

export const BalancesLabelOptions = {
  FUTURES: "Futures",
  BROKER_DEALER: "Broker Dealer",
  CASH: "Cash",
  MARGIN: "Margin",
  SHORT: "Short",
  SPECIAL_SUBSCRIPTION: "Special Subscription",
  FUNDING: "Funding",
  RESTRICTED: "Restricted",
  DIV_INT_PAYABLE: "Dividend Interest Payable",
  DIV_INT_RECEIVABLE: "Dividend Interest Receivable",
  CREDIT_INTEREST: "Credit Interest",
  TEFRA_ESCROW: "TEFRA Escrow",
  MONEY_MARKET: "Money Market",
  NON_CONVERTIBLE_BONDS: "Non-Convertible Bonds",
} as const;

type BalancesLabelKey = keyof typeof BalancesLabelOptions;

export const balancesEnumToLabel = (labelKey: string) => {
  const result = BalancesLabelOptions[labelKey as BalancesLabelKey];
  if (result) {
    return result;
  }
  return enumToCapitalCase(labelKey);
};
